import keyboard from 'keyboardjs'

const Shortcut = {
  install: function (Vue, options) {
    const shortcut = {}
    shortcut.bind = (keyComboStr, pressHandler, releaseHandler, preventRepeatByDefault) => {
      keyboard.bind(keyComboStr, (e) => {
        if (typeof pressHandler === 'function') {
          e.preventDefault()
          pressHandler(e)
        }
      }, (e) => {
        if (typeof releaseHandler === 'function') {
          e.preventDefault()
          releaseHandler(e)
        }
      }, preventRepeatByDefault)
    }
    shortcut.on = shortcut.addListener = shortcut.bind
    shortcut.unbind = keyboard.unbind
    shortcut.setContext = keyboard.setContext.bind(keyboard)

    Vue.$shortcut = shortcut
    Vue.prototype.$shortcut = shortcut
  }
}

export default Shortcut



// WEBPACK FOOTER //
// ./src/plugins/shortcut.js